const prefix = 'MAPPING/';
export const SET = prefix + 'SET';
export const RESET = prefix + 'RESET';
